<div class="inputTitle" *ngIf="label">
    <span>{{label}}</span>
</div>

<div class="phone-form exp" fxLayout="row" [class.errorBorderIntellisense]="errors?.length"
    [class.has-errors]="errors?.length" *ngIf="isEditable">
    <ng-select appearance="standard" [class.removeCross]="removeCross" [items]="options" [multiple]="false"
        [ngModel]="selected_country" (ngModelChange)="onCountryChange($event)" [bindValue]="null" [loading]="loading"
        [addTag]="false" [hideSelected]="true" [compareWith]="compareField" [trackByFn]="trackByFn"
        [typeahead]="searchText" ngOptionHighlight [disabled]="disabled" [clearable]="true"
        [placeholder]="countryPlaceholder" (change)="setFocusToNumber()">
        <ng-template ng-label-tmp let-item="item">
            <div class="country-flag">
                <img [src]="baseApiUrl + item.flag_url" class="inputFlag" />
                {{item.isd_code}}
            </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="isd-container" fxLayout="row wrap">
                <div class="country-flag" fxFlex="25">
                    <img [src]="baseApiUrl + item.flag_url" />
                </div>
                <div fxFlex="75" fxLayout="column">
                    <span class="country-code">{{item.isd_code}}</span>
                    <span class="country-name">{{item.name}}</span>
                </div>
            </div>
        </ng-template>
    </ng-select>
    <div class="numberInp">
        <span class="spliter">-</span>
        <input class="pni" matInput type="number" [ngModel]="national_number" [placeholder]="placeholder"
            (ngModelChange)="onNumberChange($event)" #numberField>
    </div>
</div>
<!-- </div> -->

<div class="viewLable" *ngIf="!isEditable">
    <span>{{getDisplay()}}</span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error top-2">{{item}}</li>
</ul>